<div class="dialogContent calcHeight content">
    <div class="schwab-blue-info-card block" *ngIf="showResetAgreementBanner">
        The Model Market Center User Agreement was reset at {{lastResetDate}}.
        <span class="pi pi-times" (click)="showResetAgreementBanner=false"></span>
    </div>
  <irb-settings-dialog-banner [accordian]="accordian" [showUnsavedChangesWarning]="showUnsavedChangesWarning"
                              [isModified]="isModified" [validationErrorTemplates]="validationErrorTemplates" (save)="save()">Model Market Center</irb-settings-dialog-banner>
  <div class="body">
    <mat-accordion #accordian="matAccordion" [multi]="true">
      <mat-expansion-panel id="MODEL_MARKET_CENTER_ASSET_CLASS" *ngIf="modelMarketSettings"
                           [expanded]="iss.getDefaultExpansionState('MODEL_MARKET_CENTER_ASSET_CLASS')"
                           (opened)="iss.updateExpansionState('MODEL_MARKET_CENTER_ASSET_CLASS','opened')"
                           (closed)="iss.updateExpansionState('MODEL_MARKET_CENTER_ASSET_CLASS','closed')">
        <mat-expansion-panel-header>
          <mat-panel-title>
            Asset Class
          </mat-panel-title>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <irb-mmc-asset-class-settings [data]="modelMarketSettings?.data?.modelMarketGlobalSettings?.ASSET_CLASS"
                                        [originalData]="originalModelMarketSettings?.data?.modelMarketGlobalSettings?.ASSET_CLASS"
                                        (changed)="onAssetClassChanged($event)"></irb-mmc-asset-class-settings>
        </ng-template>
      </mat-expansion-panel>
      <mat-expansion-panel id="MODEL_MARKET_CENTER_RISK_TOLERANCE" *ngIf="modelMarketSettings"
                           [expanded]="iss.getDefaultExpansionState('MODEL_MARKET_CENTER_RISK_TOLERANCE')"
                           (opened)="iss.updateExpansionState('MODEL_MARKET_CENTER_RISK_TOLERANCE','opened')"
                           (closed)="iss.updateExpansionState('MODEL_MARKET_CENTER_RISK_TOLERANCE','closed')">
        <mat-expansion-panel-header>
          <mat-panel-title>
            Risk Tolerance
          </mat-panel-title>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <irb-mmc-risk-tolerance-settings [data]="modelMarketSettings?.data?.modelMarketGlobalSettings?.RISK_TOLERANCE"
                                           [originalData]="originalModelMarketSettings?.data?.modelMarketGlobalSettings?.RISK_TOLERANCE"
                                           (changed)="onRiskTypeChanged($event)"></irb-mmc-risk-tolerance-settings>
        </ng-template>
      </mat-expansion-panel>
      <mat-expansion-panel id="MODEL_MARKET_CENTER_ASSET_TYPE" *ngIf="modelMarketSettings"
                           [expanded]="iss.getDefaultExpansionState('MODEL_MARKET_CENTER_ASSET_TYPE')"
                           (opened)="iss.updateExpansionState('MODEL_MARKET_CENTER_ASSET_TYPE','opened')"
                           (closed)="iss.updateExpansionState('MODEL_MARKET_CENTER_ASSET_TYPE','closed')">
        <mat-expansion-panel-header>
          <mat-panel-title>
            Asset Type
          </mat-panel-title>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
           <irb-mmc-asset-type-settings [data]="modelMarketSettings?.data?.modelMarketGlobalSettings?.ASSET_TYPE"
                                        [originalData]="originalModelMarketSettings?.data?.modelMarketGlobalSettings?.ASSET_TYPE"
                                        (changed)="onAssetTypeChanged($event)"></irb-mmc-asset-type-settings>
        </ng-template>
      </mat-expansion-panel>
      <mat-expansion-panel id="MODEL_MARKET_CENTER_BILLING_DEFAULTS" *ngIf="modelMarketSettings"
                           [expanded]="iss.getDefaultExpansionState('MODEL_MARKET_CENTER_BILLING_DEFAULTS')"
                           (opened)="iss.updateExpansionState('MODEL_MARKET_CENTER_BILLING_DEFAULTS','opened')"
                           (closed)="iss.updateExpansionState('MODEL_MARKET_CENTER_BILLING_DEFAULTS','closed')">
        <mat-expansion-panel-header>
          <mat-panel-title>
            Billing Defaults
          </mat-panel-title>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <irb-mmc-billing-defaults-settings [data]="modelMarketSettings?.data?.mmcNerTierList" (changed)="onMmcNerTierListChanged($event)"></irb-mmc-billing-defaults-settings>
        </ng-template>
      </mat-expansion-panel>

        <mat-expansion-panel id="MODEL_MARKET_CENTER_USER_AGREEMENT"
                             [expanded]="iss.getDefaultExpansionState('MODEL_MARKET_CENTER_USER_AGREEMENT')"
                             (opened)="iss.updateExpansionState('MODEL_MARKET_CENTER_USER_AGREEMENT','opened')"
                             (closed)="iss.updateExpansionState('MODEL_MARKET_CENTER_USER_AGREEMENT','closed')">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    User Agreement
                </mat-panel-title>
            </mat-expansion-panel-header>
            <ng-template matExpansionPanelContent>
                <div class="block bold" style="margin-left: 10px;">Reset User Agreement for All Users</div>
                <div class="block" style="margin-left: 10px;">Users will not be able to use the Model Market Center again until they accept the updated user agreement.</div>
                <div class="block lastUserAgreementReset" style="margin-left: 10px;">Date of last reset: {{lastResetDate}}</div>
                <button id="resetAgreementButton" (click)="resetUserAgreementClick()" class="btn-medium-secondary">Reset User Agreement</button>
            </ng-template>
        </mat-expansion-panel>
        <mat-expansion-panel id="MODEL_MARKET_CENTER_CUSTOM_DISCLOSURE"
                             [expanded]="iss.getDefaultExpansionState('MODEL_MARKET_CENTER_CUSTOM_DISCLOSURE')"
                             (opened)="iss.updateExpansionState('MODEL_MARKET_CENTER_CUSTOM_DISCLOSURE','opened')"
                             (closed)="iss.updateExpansionState('MODEL_MARKET_CENTER_CUSTOM_DISCLOSURE','closed')">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    Custom Model Disclosure
                </mat-panel-title>
            </mat-expansion-panel-header>
            <ng-template matExpansionPanelContent>
                <div id="toolBar1">
                    <img (click)="cleanDocMdl();" class="intLink clickable" src="../../../../assets/images/cleanDoc.png"
                         title="Clean"/>

                    <img (click)="printDoc();" class="intLink clickable" src="../../../../assets/images/printDoc.png"
                         title="Print"/>

                    <img (click)="formatDocMdl('undo');" class="intLink clickable" src="../../../../assets/images/undo.png"
                         title="Undo"/>

                    <img (click)="formatDocMdl('redo');" class="intLink clickable" src="../../../../assets/images/redo.png"
                         title="Redo"/>

                    <img (click)="formatDocMdl('removeFormat')" class="intLink clickable"
                         src="../../../../assets/images/undoFormat.png"
                         title="Remove formatting"/>

                    <img (click)="formatDocMdl('bold');" class="intLink clickable" src="../../../../assets/images/bold.png"
                         title="Bold"/>

                    <img (click)="formatDocMdl('italic');" class="intLink clickable" src="../../../../assets/images/italic.png"
                         title="Italic"/>

                    <img (click)="formatDocMdl('underline');" class="intLink clickable"
                         src="../../../../assets/images/underline.png"
                         title="Underline"/>

                    <img (click)="formatDocMdl('justifyleft');" class="intLink clickable"
                         src="../../../../assets/images/justifyLeft.png"
                         title="Left align"/>

                    <img (click)="formatDocMdl('justifycenter');" class="intLink clickable"
                         src="../../../../assets/images/justifyCenter.png"
                         title="Center align"/>

                    <img (click)="formatDocMdl('justifyright');" class="intLink clickable"
                         src="../../../../assets/images/justifyRight.png"
                         title="Right align"/>

                    <img (click)="formatDocMdl('insertorderedlist');" class="intLink clickable"
                         src="../../../../assets/images/insertOrderedList.png"
                         title="Numbered list"/>

                    <img (click)="formatDocMdl('insertunorderedlist');" class="intLink clickable"
                         src="../../../../assets/images/bulletList.png"
                         title="Dotted list"/>

                    <img (click)="formatDocMdl('outdent');" class="intLink clickable"
                         src="../../../../assets/images/indentation.png"
                         title="Add indentation"/>

                    <img (click)="formatDocMdl('indent');" class="intLink clickable"
                         src="../../../../assets/images/deleteindentation.png"
                         title="Delete indentation"/>

                    <img (click)="addLinkMdl()" class="intLink clickable" src="../../../../assets/images/link.png"
                         title="Link"/>
                </div>

                <iframe id="customMdlDisclosureText" name="customMdlDisclosureEditor"
                        style="width: 99%; height: 150px; border: 1px solid #CECECE;" (load)="loadMdlDisclosureText()"></iframe>
            </ng-template>
        </mat-expansion-panel>

        <mat-expansion-panel id="MODEL_MARKET_CENTER_REPORTING_INVOICE" *ngIf="modelMarketSettings"
                             [expanded]="iss.getDefaultExpansionState('MODEL_MARKET_CENTER_REPORTING_INVOICE')"
                             (opened)="iss.updateExpansionState('MODEL_MARKET_CENTER_REPORTING_INVOICE','opened')"
                             (closed)="iss.updateExpansionState('MODEL_MARKET_CENTER_REPORTING_INVOICE','closed')">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    Reporting and Invoice
                </mat-panel-title>
            </mat-expansion-panel-header>
            <ng-template matExpansionPanelContent>
                <irb-mmc-reporting-invoice></irb-mmc-reporting-invoice>
            </ng-template>
        </mat-expansion-panel>
    </mat-accordion>
  </div>
</div>
